import * as React from 'react'
import Button from '@mulesoft/anypoint-components/lib/Button'
import { isPCE } from '../../../../util/environments'
import { defaultInstruction, pceInstruction } from '../../util/DownloadAmInstructionHelper'

export type ValueProps = {
    downloadInstaller: () => void,
}

export type Props = ValueProps

const DownloadAmButton = (props: Props) => {
  return (
    <div>
        <Button
            className={'download-installer-button'}
            testId={'download-installer-button'}
            onClick={props.downloadInstaller}
        >
            Download am.zip
        </Button>
    </div>
  )
}

export const DownloadAmInstruction = (props: Props) => {
  const instruction = !isPCE() ? defaultInstruction : pceInstruction
  return (
    <div className={'hybrid-settings-download-installer'} data-test-id="hybrid-settings-download-installer">
    <span>{instruction}</span>
    {
      !isPCE() && <DownloadAmButton downloadInstaller={props.downloadInstaller}/>}
    </div>
  )
}
